module.exports = __webpack_public_path__ + "static/todo-0fa9508cdb823247782c6dcf3cda8d00.png";